import { Avatar, Box, Typography } from '@mui/material';
import Icon from '../../../Assets/Icon/CustomIcon';

// 작업허가서 요청한 유저의 정보 컴포넌트
export default function UserInfo({ name, department, position, userImg }) {
  const fields = [
    { text: name, fontSize: '16px' },
    { text: department, fontSize: '14px', color: '#8B8888' },
    { text: position, fontSize: '14px', color: '#8B8888' },
  ];
  return (
    <Box
      sx={{
        width: '100%',
        display: ' flex',
        alignItems: 'center',
        gap: '8px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '56px',
          height: '56px',
          border: ' 1px solid #EEEEEE',
          borderRadius: ' 100%',
          backgroundColor: userImg ? 'transparent' : '#F2F2F2',
        }}
      >
        {userImg ? (
          <Avatar
            src={userImg}
            alt="프로필 이미지"
            sx={{ width: 52, height: 52 }}
          />
        ) : (
          <Icon.User />
        )}
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        {fields.map((field, idx) => (
          <Typography
            key={idx}
            sx={{ fontSize: field.fontSize, color: field.color || 'inherit' }}
          >
            {field.text}
          </Typography>
        ))}
      </Box>
    </Box>
  );
}
